import InfiniteScroll from 'react-infinite-scroll-component';
import { useId, useMemo } from 'react';
import { NAVUpdateLogItem } from '@/modules/issuer-dashboard/components/class-tabs/NAVUpdateLogsList.tsx';
import { useIssuerNotificationsListQuery } from '@/modules/issuer-dashboard/queries/event-logs.ts';
import { BaseModalProps, ChartEmptyState, ModalContentWrapper, Spinner } from 'ui';

interface IssuerAuditLogDividendModalProps extends BaseModalProps {
  dividend_event_id: number;
  registerId: string;
  isDeleted?: boolean;
}

export const IssuerAuditLogDividendModal = ({
  dividend_event_id,
  registerId,
  isDeleted = false,
  open,
  onClose,
}: IssuerAuditLogDividendModalProps) => {
  const scrollableId = useId();
  const {
    data: dataNotificationsList,
    fetchNextPage,
    hasNextPage,
    isError,
    isLoading,
  } = useIssuerNotificationsListQuery(
    {
      page: 1,
      page_size: 15,
      dividend_event_id,
      is_deleted: isDeleted,
    },
    registerId,
  );

  const notifications = useMemo(
    () => (dataNotificationsList?.pages || []).flatMap(({ data }) => data),
    [dataNotificationsList],
  );

  return (
    <ModalContentWrapper
      variant="right"
      title="Audit log"
      open={open}
      onClose={onClose}
      scrollableTarget={scrollableId}
    >
      {!notifications?.length && (
        <div className="flex justify-center items-center font-medium text-lg">
          <ChartEmptyState isError={isError} isLoading={isLoading} />
        </div>
      )}
      {!isLoading && notifications.length > 0 && (
        <InfiniteScroll
          next={fetchNextPage}
          dataLength={notifications.length}
          hasMore={hasNextPage || false}
          style={{ overflow: 'unset' }}
          loader={
            <div className="flex justify-center items-center h-16 w-full">
              <Spinner size="md" variant="primary" />
            </div>
          }
          scrollableTarget={scrollableId}
        >
          <div className="w-full flex flex-col">
            {notifications?.map(notification => (
              <NAVUpdateLogItem key={notification.id} notification={notification} inModal={true} />
            ))}
          </div>
        </InfiniteScroll>
      )}
    </ModalContentWrapper>
  );
};
